import {
  type FilterItemBase,
  FilterFormBuilder,
} from "../../../../../components/filterForms/FilterFormBuilder/FilterFormBuilder";
import { type FilterFormPropsBase } from "../../../../../components/filterForms/types/props";
import { FilterViewTypes } from "../../../../../enums/filterViewTypes";
import { ScormFiltersEnum } from "../../types/models";

export interface FilterFormProps extends FilterFormPropsBase<ScormFiltersEnum> {}

const filters: FilterItemBase<ScormFiltersEnum>[] = [
  {
    type: FilterViewTypes.DateRange,
    label: "Date Added",
    propertyName: ScormFiltersEnum.DateCreated,
  },
  {
    type: FilterViewTypes.DateRange,
    label: "Last Modified",
    propertyName: ScormFiltersEnum.DateModified,
  },
  {
    type: FilterViewTypes.MultiSelect,
    label: "Publisher",
    propertyName: ScormFiltersEnum.Publishers,
    placeholder: "All Publishers",
  },
  {
    type: FilterViewTypes.MultiSelect,
    label: "Packs",
    propertyName: ScormFiltersEnum.Packs,
    placeholder: "All Packs",
  },
  {
    type: FilterViewTypes.MultiSelect,
    label: "Software Applications",
    propertyName: ScormFiltersEnum.SoftwareApplications,
    placeholder: "All Applications",
  },
  {
    type: FilterViewTypes.MultiSelect,
    label: "Labels",
    propertyName: ScormFiltersEnum.Labels,
    placeholder: "All Labels",
  },
];

export const FilterForm = (props: FilterFormProps) => (
  <FilterFormBuilder
    filterOptions={props.filterOptions}
    filter={props.filter}
    updateFilter={props.updateFilter}
    items={filters}
  />
);
